export default "__VITE_ASSET__CPEvOCCC__"